import assetPath from '/app/packages/lebenslauf/components/src/assets/ibm-plex-sans-regular.woff';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')